import { HomeIcon, KeyIcon, UserCircleIcon } from "@heroicons/react/outline";
import React, { useEffect, useState } from "react";
import logo from "../assets/pos-logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { getBusinessEmail, handleLogin } from "../Redux/Action/auth.action";
import { Autocomplete, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authUser } = useSelector((state) => state.authReducer);
  const [loginData, setLoginData] = useState({
    business_name: "",
    email: "",
    pin: "",
  });
  const token = localStorage.getItem("token");
  const [pinError, setPinError] = useState(false);
  useEffect(() => {
    dispatch(getBusinessEmail());
  }, []);

  const filterOptionsForEmail = (options, { inputValue }) => {
    const normalizedInputValue = inputValue.toLowerCase();
    if (normalizedInputValue?.length < 3) {
      return []; // No options displayed until at least 3 characters are entered
    }
    return options?.filter((option) => {
      const combinedFields = option?.business_name?.toLowerCase();
      return combinedFields.includes(normalizedInputValue);
    });
  };

  useEffect(() => {
    if (token && authUser?.is_loggedIn && authUser?.pos_location?.length > 1) {
      navigate("/locations");
    }
  }, [authUser]);
  const handleSubmit = async () => {
    try {
      dispatch(handleLogin(loginData));
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="h-screen w-screen p-[20px] overflow-hidden bg-secondary flex items-center justify-center">
      <form className="p-[30px] shadow-2xl shadow-gray-100 w-full lg:w-[45%] bg-sidebar rounded-xl">
        <img src={logo} alt={logo} className="block mb-2 mx-auto w-48 h-9" />
        <h4 className="block text-center">Login To Your Store</h4>
        <p className="info-text w-full lg:w-[60%] mx-auto text-sm block text-center">
          Securely access your POS system to manage sales, inventory, and transactions efficiently.
        </p>

        <div className="my-[30px]">
          <label>Business Name</label>
          <div className="relative input">
            <input
              className="input-secondary"
              placeholder="Your Store Name"
              value={loginData?.business_name}
              onChange={(e) => setLoginData({ ...loginData, business_name: e.target.value })}
            />
            <HomeIcon className="input-icon w-5 h-5" strokeWidth={1.5} />
          </div>
          {/* <Autocomplete
                        className='autocomplete'
                        options={buisnessEmails?.data?.records ?? []}
                        getOptionLabel={(options) => options?.business_name}
                        filterOptions={filterOptionsForEmail}
                        noOptionsText={
                            buisnessEmails?.data?.records?.length > 0 && !search
                                ? 'Please enter at least 3 characters'
                                : 'Not found'
                        }
                        onChange={(e, v) => setLoginData({ ...loginData, business_name: v?.business_name })}
                        renderInput={(brands) => (
                            <TextField
                                placeholder='Select Business Name'
                                onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                                value={brands?.inputValue}
                                onChange={(e) => {
                                    const newInputValue = e.target.value;
                                    if (typeof newInputValue === 'string' && newInputValue?.length >= 3) {
                                        setSearch(newInputValue);
                                    } else {
                                        setSearch();
                                    }
                                }}
                                className='cursor-pointer'
                                {...brands}
                            />
                        )}
                    /> */}
        </div>
        <div className="my-[30px]">
          <label>Email</label>
          <div className="relative input">
            <input
              className="input-secondary"
              placeholder="Your Email"
              value={loginData?.email}
              onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
            />
            <UserCircleIcon className="input-icon w-5 h-5" strokeWidth={1.5} />
          </div>
        </div>
        <div className="mb-[30px]">
          <label>Pin</label>
          <div className="relative input">
            <input
              className="input-secondary"
              placeholder="Your Pin"
              value={loginData?.pin}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSubmit();
                }
              }}
              onChange={(e) => {
                if (e.target.value?.length <= 6) {
                  setLoginData({ ...loginData, pin: e.target.value });
                }
              }}
              onBlur={(e) => {
                if (e.target.value.length < 4 || e.target.value?.length > 6) {
                  setPinError(true);
                } else {
                  setPinError(false);
                }
              }}
            />
            <KeyIcon className="input-icon w-5 h-5" strokeWidth={1.5} />
          </div>
          {pinError && (
            <div className="text-red-500">
              <p>Pincode Must be 4 or 6 digits</p>
            </div>
          )}
        </div>
        <button
          type="button"
          className={`${
            !loginData?.business_name || !loginData.email || !loginData?.pin ? "cursor-not-allowed opacity-50" : ""
          } btn-primary`}
          disabled={!loginData?.business_name || !loginData.email || !loginData?.pin}
          onClick={handleSubmit}
        >
          Log In
        </button>
      </form>
    </div>
  );
};

export default Login;
